import { Box, Content } from '@robocorp/components';
import { styled } from '@robocorp/theme';
import { FC } from 'react';

export interface HeaderProps {
  /**
   * @ignore
   */
  id?: string;
  /**
   * @ignore
   */
  className?: string;
  /**
   * Header main heading
   */
  heading: string | React.ReactNode;
  /**
   * Header secondary heading
   */
  subheading?: string;
  /**
   * Header actions
   */
  actions?: React.ReactNode;
}

const HeaderStyled = styled(Box)`
  width: 100%;
  margin-bottom: 32px;
  justify-content: space-between;
`;

const StyledActions = styled(Box)`
  > *:not(:last-child) {
    margin-right: 16px;
    white-space: nowrap;
  }
`;

/**
 * Header component
 */
export const Header: FC<HeaderProps> = ({ heading, subheading, actions, ...rest }) => (
  <HeaderStyled display={['block', 'block', 'flex']} {...rest}>
    <Content maxWidth={['100%', '100%', '60%', '70%']} mb={[16, 16, 0]}>
      <h2>{heading}</h2>
      {subheading && <p>{subheading}</p>}
    </Content>
    <StyledActions display="flex" mt={[20, 20, 0]}>
      {actions}
    </StyledActions>
  </HeaderStyled>
);
